/* istanbul ignore file */
export const DASHBOARD_URL = '/dashboard'
export const LOADING_TEXT_DASHBOARD = 'Loading Programs...'
export const LOADING_TEXT_PAK = 'Submitting PAK number...'
export const PROGRAM_FIELD_TEST = 'sela field test program'
